import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell, X } from 'lucide-react';
import { onLink, takePendingLink } from '../native/links.js';
import { enablePush, onForegroundNotification } from '../native/push.js';

// Mounted once someone is signed in: turns on push for this phone, opens any
// link or tapped notification that was waiting, and shows notifications that
// arrive while the app is open (Android only shows them when it is closed).
export default function NativeBridge() {
  const navigate = useNavigate();
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    enablePush().catch(() => {});
    const pending = takePendingLink();
    if (pending) navigate(pending);
    const offLink = onLink((path) => { takePendingLink(); navigate(path); });
    const offFg = onForegroundNotification(setBanner);
    return () => { offLink(); offFg(); };
  }, [navigate]);

  useEffect(() => {
    if (!banner) return undefined;
    const t = setTimeout(() => setBanner(null), 8000);
    return () => clearTimeout(t);
  }, [banner]);

  if (!banner) return null;
  const open = () => { if (banner.link) navigate(banner.link); setBanner(null); };
  return (
    <div className="push-banner" role="status">
      <button type="button" className="push-banner-main" onClick={open}>
        <Bell size={20} aria-hidden="true" />
        <span>
          <strong>{banner.title}</strong>
          {banner.body && <span className="small">{banner.body}</span>}
        </span>
      </button>
      <button type="button" className="push-banner-close" aria-label="Dismiss" onClick={() => setBanner(null)}>
        <X size={18} aria-hidden="true" />
      </button>
    </div>
  );
}
